const actions = {
  socket_notification(context, data) {
    context.commit('addNotification', data);
  },

  async loginUser({ commit, dispatch }, user) {
    commit('loginUser', user);
    await dispatch('retrieveStructuresList', { root: true });
  },

  setUserInfoModal({ commit, dispatch }, payload) {
    commit('setUserInfo', payload);
  },

  setUserId({ commit, dispatch }, payload) {
    commit('setUserId', payload);
  },

  setCollapseSideBar({ commit, dispatch }, payload) {
    commit('setCollapse', payload);
  },

};

export default actions;
